import { IconType } from 'src/app/tinea-components/icon/enum/icon-type';

export class UiIcon {

    type: IconType | undefined;
    value: string | null = null;              // eg: './foo/bar.png' | 'icon-zap'
    alt?: string;               // custom alt for the image
    cssClass?: string;          // custom css class
    dataId?: string;            // custom id to identify element
    disabled: boolean;
    title: string | null;
    dataAttr: string | null;

    constructor() {
        this.disabled = false;
        this.alt = '';
        this.title = null;
        this.dataAttr = null;
    }
}
